import 'whatwg-fetch'; /* It's a polyfill, so you should never need to import it with a name */
import 'promise-polyfill';
import Config from '../config.js';

function fetchContent(fetchUrlEndpoint, queryString) {
  let fetchUrl = Config.endpoints[fetchUrlEndpoint];
  if (queryString) {
    fetchUrl += queryString;
  }
  return fetch(fetchUrl).then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error('Network response was not ok.');
  });
}

export default fetchContent;



// WEBPACK FOOTER //
// ./src/helpers/backend-communication.js